import { Injectable } from '@angular/core';
import { Filter } from '../filters/filters.dto';
import { TaskListConverter } from './specific-task/task-list.converter';
import { TaskListObject } from 'src/app/models/tasks/tasks-table/task-list-object.model';
import { AppService } from 'src/app/app.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TaskOperationsResponse } from 'src/app/models/interface/tasks/taskOperationsResponse';
import { TaskOperationDto } from 'src/app/models/tasks/task-operation/task-operation-dto';
import { TaskOperationConverter } from './task-operation/task-operation.converter';
import { FetchApiService } from '../core/fetch-api.service';

export interface Task {
  idTask: number;
  activity: string;
  billingId: string;
  domain: string;
  description: string;
  error: string;
  fechaError: string;
  fechaInicio: string;
  idProceso: number;
  formName: string;
  operation: string;
  orderId: string;
  serviceRef: string;
  orderType: string;
  taskType: string;
  bussinessCrmId: string;
  status: string;
  errorCode: string;
  errorDescription: string;
  comment: string;
  rfsRequest: string;
  rfsResponse: string;
  scheduler: boolean;
  actualOwnerId: string;
  queue: string;
  selected?: boolean
}

export interface TaskTree {
  crmId: string;
  orderId: string;
  type: {
    name: string;
  };
  name: string;
  description: string;
  operation: string;
  status: string;
  completed: boolean;
  dependencies: boolean;
  children: TaskTree[];
}

export interface TaskSummary {
  externalId: string;
  id?: string;
  type: {
    name: string;
  };
  action?: string;
  domain?: string;
  status?: string;
  state?: string;
  urgent?: boolean;
  project?: string;
  priority?: number;
  createdAt?: string;
  expectedStartDate?: string;
  requestStartDate?: string;
  cancellationDate?: string;
  cancellationMotive?: string;
  hasDependencies?: boolean;
  specification?: string;
  processes?: {
    id: number;
    type: string;
    name: string;
    orderId: string;
    status: string;
    originIdScai: string;
  }[];
  listsCharacteristic?: {
    in: any[];
    out: any[];
  };
  childs?: {
    action: string;
    id: string;
    type: string;
    specification: string;
    name: string;
    domain: string;
  }[];
  cancelled?: boolean;
  cancellable?: boolean;
  serviceRef?: string;
}

export interface TaskData {
  'page': number;
  'total': number;
  'elements': Task[];
}

@Injectable({
  providedIn: 'root'
})
export class TasksService {

  appData: any;

  constructor(private taskListConverter: TaskListConverter,
    private appService: AppService, private httpClient: HttpClient,
    private taskOperationConverter: TaskOperationConverter,
    private fetchApiService: FetchApiService) {
    this.appData = appService.settings;
  }

  public getTasksList(filter: Filter): Observable<TaskListObject> {
    return this.httpClient.post(`${this.appData.settings}/tasks/`, filter).pipe(
      map(
        (response: any) => {
          try {
            const taskList: any = JSON.parse(JSON.stringify(response.data));
            return this.taskListConverter.convert(taskList);
          } catch (error) {
            console.error(error);
            return TaskListObject.create();
          };
        }
      ));
  }

  getTasks(body: any): Observable<TaskData> {
    return this.httpClient.post<TaskData>(`${this.appData.webApi}/tasks/getTasksMinimumData`, body, {});
  }

  getTasksCsv(body: any): Promise<Response> {
    return this.fetchApiService.bodyStreamingRequest(`${this.appData.webApi}/tasks/getTasksCsv`,'POST',body, {});
  }

  getTaskServiceSummary(taskService: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/orders/serviceOrder/${taskService}/summary`);
  }

  getTaskProcesses(taskProcessId: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Accept': 'text/html, application/xhtml+xml, */*',
        'Content-Type': 'text/plain; charset=utf-8'
      }),
      responseType: 'text' as 'json'
    };
    return this.httpClient.get<any>(`${this.appData.webApi}/bpm/processes/${taskProcessId}/diagram`, options);
  }

  getTasksOperationsByProcess(processId: string): Observable<TaskOperationDto[]> {
    return this.httpClient.get<TaskOperationsResponse>(`${this.appData.webApi}/tasks/operationsByProcess/${processId}`)
    .pipe(map(
      (response: TaskOperationsResponse) => {
        try {
          return response.map(taskOperation => this.taskOperationConverter.convert(taskOperation));
        } catch (error) {
          console.error(error);
          return new Array<TaskOperationDto>();
        };
      }
    ));
  }

  getMyTasks(body: any): Observable<TaskData> {
    return this.httpClient.post<TaskData>(`${this.appData.webApi}/tasks/mytasks/assigned`, body, {});
  }
  getMyUnassignedTasks(body: any): Observable<TaskData> {
    return this.httpClient.post<TaskData>(`${this.appData.webApi}/tasks/mytasks/unassigned`, body, {});
  }

}
